import {
  params, shape, string, arrayOf, bool, number, extend
} from '@thd-nucleus/data-sources';
import {
  ProductPod,
  ProductImage,
  ProductBadge,
  ProductSponsored,
  ProductRating,
  ProductIdentifier,
  ProductATC
} from '@thd-olt-component-react/product-pod';
import { ProductHeader } from '@thd-olt-component-react/product-details';
import { Price } from '@thd-olt-component-react/price';
import { AddToList } from '@thd-olt-component-react/add-to-list';

export const podModel = extend(
  ProductPod,
  ProductImage,
  ProductBadge,
  ProductSponsored,
  ProductRating,
  ProductIdentifier,
  ProductATC,
  Price,
  ProductHeader,
  AddToList
);

export const productModel = extend({}, {
  itemId: string(),
  dataSource: string()
}, podModel.product);

export const udsWrappedProduct = shape({
  category: string(),
  description: string(),
  idEndDate: string(),
  idPromoDetails: string(),
  idStartDate: string(),
  strategy: string(),
  isAnchor: bool(),
  recentOrderDate: string(),
  product: params({
    dataSource: string()
  })
    .shape(productModel),
  slot: shape({
    description: string(),
    isRequired: bool(),
    name: string()
  })
});

export const buyAgainModel = {
  uds: params({
    apiName: string().isRequired(),
    appId: string(),
    key: string().isRequired(),
    storeId: string(),
    cType: string(),
    exItems: string(),
    filter: string(),
    maxProducts: number(),
    model: string(),
    showPrice: bool(),
    tableName: string(),
    userId: string().isRequired(),
    isBrandPricingPolicyCompliant: bool()
  }).shape({
    metadata: shape({
      apiName: string(),
      title: string(),
      modelName: string(),
      fallbackModelName: string(),
      type: string(),
      version: string()
    }),
    products: arrayOf(udsWrappedProduct)
  })
};